import { Icon, Icons } from '@starrez/starryui';
import React from 'react';
import { strings } from '../../../.localisation';
import { Button } from './Button';

export interface IRefreshButtonProps {
    onClick: () => void;
    disabled: boolean;
}

export const RefreshButton = ({ disabled, onClick }: IRefreshButtonProps) => {
    return (
        <Button disabled={disabled} onClick={onClick} ariaLabel={strings.Action_Refresh} title={strings.Action_Refresh}>
            <Icon Icon={Icons.Refresh} />
        </Button>
    );
};